module.exports = __webpack_public_path__ + "img/icon-success.8b8ee60d.png";